// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"1b19cff9","224":"7c3cc138","413":"6cf29f96","682":"5b319dc3","818":"6adf9cb9"}[chunkId] + ".chunk.css";
};